// extracted by mini-css-extract-plugin
export default {"two-columns":"CardWrap_two-columns__+uDPF"};